import type { ContactSaveRequest } from '@highereducation/prospect';
import {
  postProspectContact,
  PROSPECT_CONTACT_PATH,
} from '@de/services/api/contactService';
import type { SaveContactParams, SaveContactResult } from '@de/types';
import { buildProspectContactDetails } from './buildProspectContactDetails';
import { buildProspectTrackingContext } from './buildProspectTrackingContext';

function buildProspectContactBody(data: SaveContactParams): ContactSaveRequest {
  return {
    contact: {
      firstName: data.lead.firstName?.trim() ?? '',
      lastName: data.lead.lastName?.trim() ?? '',
      email: data.lead.email?.trim() ?? '',
      phoneNumber: data.lead.phoneNumber?.trim() ?? '',
      zip: data.lead.location?.postalCode?.trim() ?? '',
      details: buildProspectContactDetails(data),
      trackingContext: buildProspectTrackingContext(data),
    },
  };
}

export async function saveContact(
  data: SaveContactParams,
): Promise<SaveContactResult> {
  if (
    !data.lead.firstName?.trim() ||
    !data.lead.lastName?.trim() ||
    !data.lead.email?.trim() ||
    !data.lead.phoneNumber?.trim() ||
    !data.lead.location?.postalCode?.trim()
  ) {
    return {
      success: false,
      error: {
        code: 'VALIDATION_ERROR',
        error: 'Missing required contact information',
        path: PROSPECT_CONTACT_PATH,
      },
    };
  }

  const body = buildProspectContactBody(data);

  try {
    const result = await postProspectContact(body);

    if (!result.data?.contactId?.length) {
      return {
        success: false,
        error: {
          code: 'INVALID_RESPONSE',
          error: 'Invalid response from contact service',
          path: PROSPECT_CONTACT_PATH,
        },
      };
    }

    return {
      success: true,
      data: {
        contactId: result.data.contactId,
        transactionId: result.data.transactionId,
        retrievalUrl: result.data.retrievalUrl,
      },
    };
  } catch (error) {
    return {
      success: false,
      error: {
        code: 'NETWORK_ERROR',
        error: error instanceof Error ? error.message : 'Network error',
        path: PROSPECT_CONTACT_PATH,
      },
    };
  }
}
